import uniqBy from 'lodash/uniqBy'
import { useMemo, useState } from 'react'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'
import { useProjects } from '../../hooks/projects'
import { Project } from '../../../types'
import classNames from 'classnames'
import { useUniversalOrigin } from '../../hooks/page'

function ProjectCard({ project }: { project: Project }) {
  return (
    <div className="project">
      <Link to={`/projects/${project.slug}`}>
        <img
          alt={project.title}
          className="img-fluid image"
          src={'/' + project.imageThumb}
        />
        <div className="middle">
          <div className="text">{project.title}</div>
        </div>
      </Link>
    </div>
  )
}

export default function Projects() {
  const projects = useProjects()
  const origin = useUniversalOrigin()

  const categories = useMemo(() => {
    return uniqBy(projects, 'categoria').map((p) => p.categoria)
  }, [projects])

  const [activeFilter, setActiveFilter] = useState<string | null>(null)

  const filteredProjects = useMemo(() => {
    if (!activeFilter) {
      return projects
    }
    return projects.filter((project) => project.categoria === activeFilter)
  }, [activeFilter, projects])

  return (
    <div className="page">
      <Helmet defer={false}>
        <title>Veronellie - Chromatic layers on walls - Works</title>
        {projects.length > 0 && (
          <meta
            property="og:image"
            content={`${origin}/${projects[0].image}`}
          />
        )}
      </Helmet>
      <div>
        <div className="container-fluid">
          <div className="mb-4 justify-content-center align-items-center d-none d-md-flex flex-wrap">
            {categories.map((category, i) => {
              return (
                <div
                  onClick={() => {
                    setActiveFilter(activeFilter === category ? null : category)
                  }}
                  key={i}
                  className={classNames('filter me-3 cursor-pointer', {
                    'fw-bold': activeFilter === category,
                  })}
                >
                  {category}
                </div>
              )
            })}
          </div>
          <div className="mb-4 d-block d-md-none">
            <select
              className="form-select"
              value={activeFilter || ''}
              onChange={(e) => {
                setActiveFilter(e.target.value || null)
              }}
            >
              <option value="">Tutte le categorie</option>
              {categories.map((category, i) => {
                return (
                  <option key={i} value={category}>
                    {category}
                  </option>
                )
              })}
            </select>
          </div>

          <div className="container-fluid">
            <div className="row">
              {filteredProjects.map((project) => (
                <div className="col-md-3 mb-4" key={project.slug}>
                  <ProjectCard key={project.slug} project={project} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
